/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import { FETCH_SD_GET_ACCESS_TOKEN } from './actionTypes';

/**
 * Updates the details in the 'ExternalUserAccessToken' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchSdGetAccessTokenReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_SD_GET_ACCESS_TOKEN);

/**
 * Updates the indicator of creation of details in the 'ExternalUserAccessToken' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchSdGetAccessTokenReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_SD_GET_ACCESS_TOKEN);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchSdGetAccessTokenErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_SD_GET_ACCESS_TOKEN);

const reducers = combineReducers({
  fetchSdGetAccessToken: fetchSdGetAccessTokenReducer,

  isFetchingFetchSdGetAccessToken: isFetchingFetchSdGetAccessTokenReducer,
  fetchSdGetAccessTokenError: fetchSdGetAccessTokenErrorReducer,
});

export default { reducers };
